var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoInfopriceBranco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1_-_Principal",
    "data-name": "1 - Principal"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 190.93,
    y: 7.14,
    width: 10.55,
    height: 146.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 7.14,
    width: 18.46,
    height: 146.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34.25,
    y: 7.14,
    width: 9.5,
    height: 146.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.47,
    y: 7.14,
    width: 9.5,
    height: 146.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 156.12,
    y: 7.14,
    width: 9.5,
    height: 146.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 75.14,
    y: 7.14,
    width: 9.5,
    height: 146.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 173.79,
    y: 7.14,
    width: 9.5,
    height: 146.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 92.82,
    y: 7.14,
    width: 9.49,
    height: 146.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 121.3,
    y: 7.14,
    width: 21.1,
    height: 146.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.91,153.86V7.12h28.43V153.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.44,153.86H335.83V93.1q0-13-4.53-19a14.88,14.88,0,0,0-12.57-6,23.65,23.65,0,0,0-8.45,1.65,31.58,31.58,0,0,0-8.14,4.65,38,38,0,0,0-6.9,7.13,28.24,28.24,0,0,0-4.53,9.1v63.24H263.1V45.56H288v20a40.91,40.91,0,0,1,17.31-16.12,55.33,55.33,0,0,1,25.55-5.79q10.1,0,16.48,3.72a26.75,26.75,0,0,1,9.89,9.72,40.7,40.7,0,0,1,4.85,13.64,89.85,89.85,0,0,1,1.33,15.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M384.05,153.86V72.43H369.83V51.35h14.22V44.74q0-20.26,9.68-32T420.11.92a61.23,61.23,0,0,1,26.58,6.41L441.13,28.2a34.77,34.77,0,0,0-7.32-2.79,30.26,30.26,0,0,0-7.72-1.13q-14.43,0-14.43,19.42v7.65H438V72.43H411.66v81.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M489.14,155.92a59.17,59.17,0,0,1-23.7-4.54,53.24,53.24,0,0,1-17.82-12.3,54.2,54.2,0,0,1-11.23-17.88,58.47,58.47,0,0,1-3.91-21.28,59.14,59.14,0,0,1,3.91-21.5,54.16,54.16,0,0,1,11.23-17.87,53.24,53.24,0,0,1,17.82-12.3,59.17,59.17,0,0,1,23.7-4.55,58.36,58.36,0,0,1,23.59,4.55,53.32,53.32,0,0,1,17.72,12.3,54.35,54.35,0,0,1,11.24,17.87,59.35,59.35,0,0,1,3.91,21.5,58.68,58.68,0,0,1-3.91,21.28,55.45,55.45,0,0,1-11.13,17.88,52.13,52.13,0,0,1-17.72,12.3A59.17,59.17,0,0,1,489.14,155.92Zm-28.23-56A37.89,37.89,0,0,0,463.07,113a32.19,32.19,0,0,0,6,10.23,26.86,26.86,0,0,0,9,6.72,27.32,27.32,0,0,0,22.26,0,26.86,26.86,0,0,0,9-6.72,31.93,31.93,0,0,0,6-10.33,38.81,38.81,0,0,0,2.16-13.23,38.17,38.17,0,0,0-2.16-13,32,32,0,0,0-6-10.33,26.29,26.29,0,0,0-20.09-9.1A25.4,25.4,0,0,0,478,69.74a28.13,28.13,0,0,0-9,6.82,32.09,32.09,0,0,0-6,10.34A38.08,38.08,0,0,0,460.91,99.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M556.32,153.86V7.12h62A41.52,41.52,0,0,1,637,11.36a48.26,48.26,0,0,1,14.73,11.16,52.61,52.61,0,0,1,9.68,15.71,47.24,47.24,0,0,1,3.51,17.67A51,51,0,0,1,661.61,74a50.2,50.2,0,0,1-9.27,15.6,45.61,45.61,0,0,1-14.43,11,41.67,41.67,0,0,1-18.54,4.13H584.75v49.19Zm28.43-74.2h33a16.25,16.25,0,0,0,13.08-6.4q5.26-6.41,5.26-17.36a28.71,28.71,0,0,0-1.65-10,24.36,24.36,0,0,0-4.33-7.54,17.12,17.12,0,0,0-6.28-4.65,18.44,18.44,0,0,0-7.32-1.55H584.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M737.23,69.54a54.19,54.19,0,0,0-22.46,4.85,28.43,28.43,0,0,0-14.22,14v65.52H672.94V45.56h25.34V68.71a49.21,49.21,0,0,1,6.81-10,52,52,0,0,1,8.44-7.75,39.27,39.27,0,0,1,9.17-5.07,25.26,25.26,0,0,1,9-1.75h3.4a11.64,11.64,0,0,1,2.16.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M743.62,30.48V3h27.61V30.48Zm0,123.38V45.56h27.61v108.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M780.29,99.71a59.05,59.05,0,0,1,3.92-21.49,52.49,52.49,0,0,1,11.33-17.78,55.27,55.27,0,0,1,17.93-12.19,59.09,59.09,0,0,1,23.69-4.55q17.73,0,30.19,7.65A48.79,48.79,0,0,1,886,71.4l-27,8.26a24.29,24.29,0,0,0-9.28-9.19A25.79,25.79,0,0,0,837,67.26a26.28,26.28,0,0,0-11.13,2.38,27.36,27.36,0,0,0-9,6.61,30.59,30.59,0,0,0-6,10.23,38.81,38.81,0,0,0-2.16,13.23A37,37,0,0,0,811,112.94a33.24,33.24,0,0,0,6.07,10.33,26.8,26.8,0,0,0,9,6.72A25.79,25.79,0,0,0,837,132.36a26.42,26.42,0,0,0,13.7-3.72,20.86,20.86,0,0,0,8.76-9.09l27,8.27q-5.56,12.39-18.34,20.25t-30.7,7.85a59.17,59.17,0,0,1-23.7-4.54,53.82,53.82,0,0,1-29.36-30.28A58,58,0,0,1,780.29,99.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M943.29,155.92a59.76,59.76,0,0,1-23.49-4.44,53.08,53.08,0,0,1-29.37-29.86,57.18,57.18,0,0,1-4-21.29,60.48,60.48,0,0,1,3.92-21.8,53.24,53.24,0,0,1,11.33-18,54,54,0,0,1,18-12.3,59.91,59.91,0,0,1,23.8-4.55,58.44,58.44,0,0,1,23.6,4.55,54.45,54.45,0,0,1,17.72,12.19,52,52,0,0,1,11.12,17.78,59.35,59.35,0,0,1,3.82,21.08c0,1.79,0,3.51-.11,5.16a21.58,21.58,0,0,1-.51,4.14H915.67A32.49,32.49,0,0,0,918.76,120a28.2,28.2,0,0,0,6.39,8.48,27.91,27.91,0,0,0,8.86,5.37,29,29,0,0,0,10.31,1.86,31.71,31.71,0,0,0,15.55-4q7.32-4,10-10.64l23.69,6.61q-6,12.4-19.06,20.36T943.29,155.92Zm28-65.3q-1-12.2-9-19.53a27.34,27.34,0,0,0-19.26-7.34,27.62,27.62,0,0,0-10.41,2,27.15,27.15,0,0,0-8.55,5.48A28.48,28.48,0,0,0,918,79.66a29.86,29.86,0,0,0-2.78,11Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInfopriceBranco);
export default __webpack_public_path__ + "static/media/logo-infoprice-branco.2a180f2b838d2ddbc746b7976bb569a7.svg";
export { ForwardRef as ReactComponent };